const validateNotEmpty = value => !value ? 'Cannot be empty' : null;

const validateEmail = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9]{2,10}$/i.test(value)
    ? 'Invalid email address' : undefined;

export {
  validateEmail,
  validateNotEmpty,
};



// WEBPACK FOOTER //
// ./src/helpers/validations.js